<script setup>
import { ref,inject,onMounted,provide  } from 'vue'
import { ElMessage } from 'element-plus'
import axios from 'axios';
import { useMemberStore } from '../../stores';
import JSONbig from "json-bigint";
const userStore = useMemberStore();
const baseURL = 'https://devmini.walkertour.cn';
const rootPath = "/www/wwwroot/testMiniServer/server/dist";

const billid = inject('billid');
const forbidEdit = inject('forbidEdit');
const size = ref('default')
const labelPosition = ref('right')
const imageUrl = ref('')
const headers = ref({
	'Authorization': `${userStore.profile?.token}`,
})

const sizeForm = inject('orderForm');
const models = ref([])
const colours = ref([])
const klookDriverDatas = ref([])
onMounted(async()=>{
	if(billid.value!=null&&billid.value!=''){
		const response = await axios.post('/klook/car/queryInfo', {
		  billid:billid.value,
		}, {
		  headers: {
		    'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			sizeForm.value = JSONbig.parse(response.data.data);
			imageUrl.value = sizeForm.value.cover_image
		}
	}
	//查询车型
	const response = await axios.get('/klook/car/queryModel', {
	  headers: {
		'Content-Type': 'application/json',
		Authorization: `${userStore.profile?.token}`,
	  }
	});
	if(response.data.status===0){
		models.value = response.data.data
	}
	//查询颜色
	const colorResponse = await axios.get('/klook/car/queryColour', {
	  headers: {
		'Content-Type': 'application/json',
		Authorization: `${userStore.profile?.token}`,
	  }
	});
	if(colorResponse.data.status===0){
		colours.value = colorResponse.data.data
	}
	const driverRes = await axios.post('/klook/driver/getList', {
	}, {
	  headers: {
	    'Content-Type': 'application/json',
		Authorization: `${userStore.profile?.token}`,
	  }
	});
	if(driverRes.data.status===0){
		const datas = JSONbig.parse(driverRes.data.data);
		const sjOptions = [];
		datas&&datas.map(item=>{
			sjOptions.push({
				value:item.id,
				label:item.last_name + '·' + item.first_name
			})
		})
		klookDriverDatas.value = sjOptions;
	}
})
function onSubmit() {
  console.log('submit!')
}
const handleAvatarSuccess= (
  response,
  uploadFile
) => {
  if(response.status===0){
  	imageUrl.value = response.imgUrl.replace(rootPath,baseURL);
  	sizeForm.value.cover_image = response.imgUrl;
  }
}

const beforeAvatarUpload = (rawFile) => {
  if (rawFile.type !== 'image/jpeg'&&rawFile.type !== 'image/png') {
    ElMessage.error('Avatar picture must be JPG/PNG format!')
    return false
  } else if (rawFile.size / 1024 / 1024 > 2) {
    ElMessage.error('Avatar picture size can not exceed 2MB!')
    return false
  }
  return true
}

</script>
<template>
	<el-form
	    ref="form"
	    :model="sizeForm"
	    label-width="auto"
	    :label-position="labelPosition"
	    :size="size"
	  >
		<div style="display: flex;">
			<el-form-item label="名称" style="width: 48%;">
			  <el-input :disabled="forbidEdit" class="w-50 m-2" v-model="sizeForm.name" />
			</el-form-item>
			<el-form-item label="制造商" style="width: 48%;">
			  <el-input :disabled="forbidEdit" class="w-50 m-2" v-model="sizeForm.make" />
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="类型" style="width: 98%;">
			  <el-radio-group :disabled="forbidEdit" v-model="sizeForm.model">
			  	<el-radio v-for="(item, index) in models" :key="index" border :label="item.label" :value="item.value"/>
			  </el-radio-group>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="颜色" style="width: 98%;">
			  <el-radio-group :disabled="forbidEdit" v-model="sizeForm.colour">
				<el-radio v-for="(item, index) in colours" :key="index" border :label="item.label" :value="item.value"/>
			  </el-radio-group>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="车牌号" style="width: 48%;">
			  <el-input :disabled="forbidEdit" class="w-50 m-2" v-model="sizeForm.plate_number" />
			</el-form-item>
			<el-form-item label="默认司机" style="width: 48%;">
				<el-select
					v-model="sizeForm.default_driver"
					filterable
					:disabled="forbidEdit"
					placeholder="选择司机"
					style="width: 600px"
				>
					<el-option
					  v-for="item in klookDriverDatas"
					  :key="item.value"
					  :label="item.label"
					  :value="item.value"
					/>
				</el-select>
			</el-form-item>
		</div>
		<div style="display: flex;">
			<el-form-item label="车辆实图" style="width: 48%;">
			  <el-upload
			    class="avatar-uploader"
			    action="/manageCar/car/uploadFile"
				:headers="headers"
			    :show-file-list="false"
			    :on-success="handleAvatarSuccess"
			    :before-upload="beforeAvatarUpload"
				crossorigin="anonymous"
			  >
			    <img v-if="imageUrl" :src="imageUrl" class="avatar" />
			    <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
			  </el-upload>
			</el-form-item>
		</div>
	  </el-form>
</template>

<style scoped>
	.avatar-uploader .avatar {
	  width: 90px;
	  height: 90px;
	  display: block;
	}
	.avatar-uploader .el-upload {
	  border: 1px dashed var(--el-border-color);
	  border-radius: 6px;
	  cursor: pointer;
	  position: relative;
	  overflow: hidden;
	  transition: var(--el-transition-duration-fast);
	}
	
	.avatar-uploader .el-upload:hover {
	  border-color: var(--el-color-primary);
	}
	
	.el-icon.avatar-uploader-icon {
	  font-size: 28px;
	  color: #8c939d;
	  width: 90px;
	  height: 90px;
	  text-align: center;
	}
</style>